import axios from "axios";
import { defaultVariables } from "./index";

export const PAYMENT_GATEWAYS = {
    param: "param",
    iyzipay: "iyzipay",
};

export function gatewayFromSetting(setting, industryName) {
    if (!setting) {
        return PAYMENT_GATEWAYS.param;
    }
    const industry = String(industryName || "").toLowerCase();
    if (industry === "markets") {
        return setting.markets_payment_gateway || PAYMENT_GATEWAYS.param;
    }
    return setting.restaurants_payment_gateway || PAYMENT_GATEWAYS.param;
}

export function walletDepositGatewayFromSetting(setting) {
    return setting?.wallet_deposit_payment_gateway || PAYMENT_GATEWAYS.param;
}

export async function fetchPaymentGateway({ context, shopId, walletHistoryId, orderId, token }) {
    const params = new URLSearchParams({ context });
    if (shopId != null) {
        params.set("shop_id", String(shopId));
    }
    if (walletHistoryId != null) {
        params.set("wallet_history_id", String(walletHistoryId));
    }
    if (orderId != null) {
        params.set("order_id", String(orderId));
    }
    const headers = {
        Accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    const { data } = await axios.get(
        `${defaultVariables.url}/payment/gateway?${params.toString()}`,
        { headers },
    );
    return data;
}

export function cardsApiPath(gateway) {
    if (gateway === PAYMENT_GATEWAYS.iyzipay) {
        return `${defaultVariables.url}/payments/cards?provider=iyzipay`;
    }
    return `${defaultVariables.url}/payment-methods`;
}

export function saveCardApiPath(gateway) {
    if (gateway === PAYMENT_GATEWAYS.iyzipay) {
        return `${defaultVariables.url}/payments/cards/save`;
    }
    return `${defaultVariables.url}/payment-methods`;
}

export function deleteCardApiPath(gateway, id) {
    if (gateway === PAYMENT_GATEWAYS.iyzipay) {
        return `${defaultVariables.url}/payments/cards/${id}`;
    }
    return `${defaultVariables.url}/payment-methods/${id}`;
}

export function payPagePath(gateway, transactionId, orderId) {
    const base = gateway === PAYMENT_GATEWAYS.iyzipay ? "iyzipay-pay" : "param-pay";
    if (orderId != null) {
        return `/account/${base}/${transactionId}/${orderId}`;
    }
    return `/account/${base}/${transactionId}`;
}

/** Open iyzico 3DS HTML (auto-submit form) in the current window. */
export function openIyzicoThreeDsHtml(htmlContent) {
    if (!htmlContent) {
        return;
    }
    const doc = document.open("text/html", "replace");
    doc.write(htmlContent);
    doc.close();
}

export async function startGatewayPayment({
    walletHistoryId,
    paymentMethodId,
    platform,
    orderId,
    token,
}) {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
    };
    const frontendBase =
        typeof window !== "undefined" && window.location?.origin
            ? window.location.origin
            : undefined;

    const body = {
        wallet_history_id: Number(walletHistoryId),
        payment_method_id: Number(paymentMethodId),
        platform,
        ...(orderId != null ? { order_id: Number(orderId) } : {}),
        ...(frontendBase ? { frontend_base_url: frontendBase } : {}),
    };

    const { data } = await axios.post(
        `${defaultVariables.url}/payment/stored-start`,
        body,
        { headers },
    );
    return data;
}
